export default __webpack_public_path__ + "static/atoms-3f225cdb771189fed325720ac136ca82.png";